module.exports = __webpack_public_path__ + "static/media/powered-by-avax.3d02ba3b.png";